import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Division } from '../../../models/division.model';
import { CompaniesService } from '../../../services/company/companies.service';
import { DivisionService } from './../../../services/division/division.service';

@Component({
  selector: 'app-division-form',
  templateUrl: 'divisionForm.component.html',
  styles: ['label.required:after {top: 0}']
})

export class DivisionFromComponent implements OnInit {
  @Output() divisionAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() divisionUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxDivision: Division;
  addEditForm: FormGroup;
  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private srvCompany: CompaniesService,
    private divisionService: DivisionService) {
  }

  ngOnInit(): void {

    this.divisionService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.addEditForm = this.fb.group({
      'code': new FormControl(this.dialogBoxDivision.code),
      'name': new FormControl(this.dialogBoxDivision.name),
      'description': new FormControl(this.dialogBoxDivision.description),
      'logo_name': new FormControl(this.dialogBoxDivision.logo_name),
      'logo': new FormControl(this.dialogBoxDivision.logo)
    });
  }

  // onChangeCompany(e) {
  //    let obj = this.companies.filter(x => x.value === e.value);
  //    this.addEditForm.controls['company_name'].setValue(obj[0].label);
  // }

  saveOrUpdate(dialogBox: any): void {
    // console.log('request to insert or update division');
    // console.log(this.dialogBoxDivision);

    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxDivision, this.addEditForm.value);
    if (newData.id == null) {
      this.divisionAdded.emit(newData);
    } else {
      this.divisionUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/division/divisionForm.component.ts